import { OperacionListadoEjecutivo } from '@/models/respuestas/detalleOperacion.model';
import { FiltrosOpEjecutivo } from '@/redux/slices/operacionesSlice/operacionesSlice';

export const nroOperacionEsValida = (
  { nroOperacion }: OperacionListadoEjecutivo,
  query: string
) => {
  if (query.length === 0) return true;
  return nroOperacion.toString().includes(query);
};

export const datosClienteSonValidos = (
  { razonSocialCliente, rutCliente }: OperacionListadoEjecutivo,
  query: string
) => {
  if (query.length === 0) return true;
  const busqueda = query.trim().toLowerCase();
  return (
    razonSocialCliente.toLowerCase().includes(busqueda) ||
    rutCliente.toLowerCase().includes(busqueda)
  );
};

export const filtrarOperaciones = (
  operaciones: OperacionListadoEjecutivo[],
  { nroOperacion, datosCliente, estados }: FiltrosOpEjecutivo
) => {
  const resultado = operaciones.filter(
    (o) =>
      datosClienteSonValidos(o, datosCliente) &&
      nroOperacionEsValida(o, nroOperacion) &&
      estados[o.idEstado]
  );

  return resultado;
};
